import { render } from "./more_terBid.vue?vue&type=template&id=75027906"
import script from "./more_terBid.vue?vue&type=script&lang=js"
export * from "./more_terBid.vue?vue&type=script&lang=js"

import "./more_terBid.vue?vue&type=style&index=0&id=75027906&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__